import { useSearchParams } from "next/navigation";

export const useQueryString = () => {
    const searchParams = useSearchParams();
    const queryString = searchParams.toString()
        ? `?${searchParams.toString()}`
        : "";

    return queryString;
};
